import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { ScheduleEventActionContent } from "../Component/EventScheduleManageContent";

const EventScheduleManage = () => {
  const seoData = getSEOData("/event-schedule");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <ScheduleEventActionContent />
    </>
  );
};

export default EventScheduleManage;
